import React from 'react';
import mark from '../assets/images/panelgear-mark.png';

/**
 * The PanelGear attribution under the form.
 *
 * The mark is applied as a CSS mask filled with `currentColor` rather than
 * drawn as an image: the artwork is a solid black gear on transparency, which
 * would disappear against a shop that has chosen a dark page colour. Masking it
 * means it always takes the surrounding text colour, whatever palette the shop
 * picks.
 *
 * The wordmark uses Supercharge via --font-brand, the same face the admin app
 * uses for the PanelGear name.
 */
const PoweredBy = ({ className = '' }) => (
  <p className={`flex items-center justify-center gap-1.5 text-muted-foreground ${className}`}>
    <span className="text-[11px]">Powered by</span>

    <span
      aria-hidden="true"
      className="h-3.5 w-3.5 shrink-0 bg-current"
      style={{
        maskImage: `url(${mark})`,
        WebkitMaskImage: `url(${mark})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center'
      }}
    />

    <span className="font-brand text-sm leading-none tracking-wide">PanelGear</span>
  </p>
);

export default PoweredBy;
